import { Alert, Typography } from "@mui/material";
import { Control, FieldValues, useFormState } from "react-hook-form";

type Props<T extends FieldValues = FieldValues> = {
    control: Control<T>;
};

export function GaiaHookFormRootErrorAlert<T extends FieldValues>({ control }: Props<T>) {
    const { errors } = useFormState({ control });

    if (errors === undefined || errors.root === undefined) {
        return null;
    }

    return (
        <Alert severity="error">
            <Typography>{errors.root.message}</Typography>
        </Alert>
    );
}
